export function int31() {
    return Math.floor(Math.random() * 0x7FFFFFFF);
}
